import { Button, TableCell, TableRow } from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";

import { useStyles } from "./styles";

import _, { isString } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { AppContext } from "../../AppContext";
import arrowIcon from "../../images/ri_arrow-up-s-line.svg";

const OrderItemTableEntry = ({
    item,
    selectedOrder,
    handlePayloadGenerated,
    image,
    payingAll,
}) => {
    const classes = useStyles();

    const [itemAddons, setItemAddons] = useState([]);

    const [qty, setQty] = useState(item.qty);
    const [rate, setRate] = useState(item.rate);

    const [toQty, setToQty] = useState(0);
    const [toRate, setToRate] = useState(0);

    const { menuAddons } = useContext(AppContext);

    const addonsItems = useMemo(() => {
        return menuAddons || [];
    }, [menuAddons]);

    const calculateRate = (item) => {
        let addonsCost = 0;
        if (item.addons) {
            const itemAddons = JSON.parse(item.addons);

            itemAddons.map((itemCode) => {
                const _item = isString(itemCode)
                    ? addonsItems.find((i) => i.item_code === itemCode)
                    : itemCode;
                addonsCost += _item?.standard_rate || 0;
            });
            const rate = item.rate + addonsCost;
            return rate;
        }
        return addonsCost;
    };

    useEffect(() => {
        setQty(item.qty);
        setRate(calculateRate(item));
        // setRate(item.rate);
        setToQty(0);
        setToRate(0);

        const tmpItemAddons = item.addons
            ? JSON.parse(item.addons)
                  .map((addon) =>
                      _.find(
                          menuAddons,
                          (a) => _.toLower(a.item_code) === _.toLower(addon)
                      )
                  )
                  .filter(Boolean)
            : [];

        setItemAddons(tmpItemAddons);
    }, [item, addonsItems]);

    const getIcon = () => {
        return (
            <div>
                <img src={arrowIcon} />
            </div>
        );
    };

    const handleMoveLeft = (item) => {
        if (toQty > 0) {
            setToQty(toQty - 1);
            setQty(qty + 1);
        }
    };

    const handleMoveRight = (item) => {
        if (toQty + 1 <= item.qty) {
            setQty(qty - 1);
            setToQty(toQty + 1);
        }
    };

    const preparePayload = () => {
        const entryId = item.identifier;
        const payload = {
            name: item.name,
            qty: Number(toQty),
            // identifier: entryId, // "entry_obj_d83e-a1-434-ba9-76220"
            identifier: "entry_" + uuidv4(), // "entry_obj_d83e-a1-434-ba9-76220"
        };

        if (handlePayloadGenerated)
            handlePayloadGenerated(item.identifier, payload);
    };

    useEffect(() => {
        preparePayload();
    }, [toQty]);

    return (
        <TableRow>
            <TableCell>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleMoveRight(item)}
                    className={classes.smallButton}
                >
                    {">>"}
                </Button>
            </TableCell>
            <TableCell style={{ width: "30px", height: "30px" }}>
                <img src={image} alt="Image" />
            </TableCell>
            <TableCell>
                <span className={classes.itemCode}>{item.item_code}</span>
                <br />
                {itemAddons &&
                    itemAddons.map((i, index) => (
                        <div
                            className={classes.itemAddon}
                            key={`${
                                "Payment_Dialog_Addons_" + item.identifier
                            }_${index}`}
                        >
                            <span>- {i.item_code}</span>
                        </div>
                    ))}
            </TableCell>
            <TableCell
                style={
                    payingAll
                        ? {
                              color: "blue",
                              fontStyle: "italic",
                              fontWeight: "bold",
                              textDecoration: "underline",
                          }
                        : {}
                }
            >
                {qty}
            </TableCell>
            <TableCell
                style={
                    payingAll
                        ? {
                              color: "blue",
                              fontStyle: "italic",
                              fontWeight: "bold",
                              textDecoration: "underline",
                          }
                        : {}
                }
            >
                {rate * qty}
            </TableCell>
            <TableCell
                style={
                    toQty > 0
                        ? {
                              color: "green",
                              fontStyle: "italic",
                              fontWeight: "bold",
                              textDecoration: "underline",
                          }
                        : {}
                }
            >
                {toQty}
            </TableCell>
            {/*<TableCell>{rate * toQty}</TableCell>*/}
            <TableCell
                style={
                    toQty > 0
                        ? {
                              color: "green",
                              fontStyle: "italic",
                              fontWeight: "bold",
                              textDecoration: "underline",
                          }
                        : {}
                }
            >
                {rate * toQty}
            </TableCell>
            <TableCell>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleMoveLeft(item)}
                    className={classes.smallButton}
                >
                    {"<<"}
                </Button>
            </TableCell>
        </TableRow>
    );
};

export default OrderItemTableEntry;
